"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customerQueries = exports.customerQueryKeys = void 0;
const customer_api_1 = require("./customer.api");
exports.customerQueryKeys = {
    all: () => ['customers'],
    languages: () => [...exports.customerQueryKeys.all(), 'languages'],
    titles: () => [...exports.customerQueryKeys.all(), 'titles'],
    genders: () => [...exports.customerQueryKeys.all(), 'genders'],
    countries: () => [...exports.customerQueryKeys.all(), 'countries'],
    preferencesNewsletter: () => [...exports.customerQueryKeys.all(), 'preferencesNewsletter'],
    emailExists: (params) => [...exports.customerQueryKeys.all(), 'exists', params],
    getDeliveryAddresses: () => [...exports.customerQueryKeys.all(), 'deliveryAddresses'],
    profile: () => [...exports.customerQueryKeys.all(), 'profile'],
};
const customerQueries = (apiOptions) => ({
    getLanguages: () => ({
        queryKey: exports.customerQueryKeys.languages(),
        queryFn: () => (0, customer_api_1.getLanguages)(apiOptions),
    }),
    getTitles: (params, options = {}) => (Object.assign({ queryKey: exports.customerQueryKeys.titles(), queryFn: () => (0, customer_api_1.getTitles)(apiOptions, params), select: (data) => ({
            options: data
                .sort((t1, t2) => (t1.sortOrder && t2.sortOrder ? t1.sortOrder - t2.sortOrder : 0))
                .map(title => ({ value: title.id, label: title.title })) || null,
            hasGenderField: Boolean(data.some(title => !title.idGender || title.idGender === '-1')),
        }) }, options)),
    getGenders: (params) => ({
        queryKey: exports.customerQueryKeys.genders(),
        queryFn: () => (0, customer_api_1.getGenders)(apiOptions, params),
    }),
    getCountries: (options = {}) => (Object.assign(Object.assign({}, options), { queryKey: exports.customerQueryKeys.countries(), queryFn: () => (0, customer_api_1.getCountries)(apiOptions) })),
    getPreferencesNewsletter: (params, options) => (Object.assign(Object.assign({}, options), { queryKey: exports.customerQueryKeys.preferencesNewsletter(), queryFn: () => (0, customer_api_1.getPreferencesNewsletter)(apiOptions, params) })),
    getEmailExists: (params, options = {}) => (Object.assign(Object.assign({}, options), { queryKey: exports.customerQueryKeys.emailExists(params), queryFn: () => (0, customer_api_1.getEmailExists)(apiOptions, params) })),
    getDeliveryAddresses: (options = {}) => (Object.assign(Object.assign({}, options), { queryKey: exports.customerQueryKeys.getDeliveryAddresses(), queryFn: () => (0, customer_api_1.getDeliveryAddresses)(apiOptions) })),
    getProfile: () => ({
        queryKey: exports.customerQueryKeys.profile(),
        queryFn: () => (0, customer_api_1.getProfile)(apiOptions),
    }),
});
exports.customerQueries = customerQueries;
//# sourceMappingURL=customer.queries.js.map